/*
 * Copyright (c) 2025 AirAsia Berhad (Malaysia). All rights reserved.
 *
 * This software is proprietary and confidential. Unauthorized copying of this file,
 * via any medium, is strictly prohibited. Do not distribute, copy, modify, or reuse
 * any part of this code without explicit written permission from AirAsia Move.
 *
 * For internal use only.
 */

import { useOptionalHotelIntegration } from './HotelIntegrationsProvider';
import type {
  HotelMalaysianEInvoiceParams,
  HotelMalaysianEInvoiceResult,
  HotelNearestAirportsResult,
} from './types';

const EMPTY_NEAREST_AIRPORTS_RESULT: HotelNearestAirportsResult = {
  data: undefined,
  isLoading: false,
};

const NOOP_MALAYSIAN_E_INVOICE_RESULT: HotelMalaysianEInvoiceResult = {
  handleMalaysianEInvoicePress: async () => undefined,
  isLoadingEInvoice: false,
};

/**
 * Stable no-op adapters. Hosts must pass module-level hook references so the
 * resolved hook identity does not change between renders (Rules of Hooks).
 */
export const fallbackUseNearestAirports = (): HotelNearestAirportsResult =>
  EMPTY_NEAREST_AIRPORTS_RESULT;

export const fallbackUseMalaysianEInvoice = (
  _params: HotelMalaysianEInvoiceParams,
): HotelMalaysianEInvoiceResult => NOOP_MALAYSIAN_E_INVOICE_RESULT;

export const useResolvedNearestAirports = (): HotelNearestAirportsResult => {
  const useImpl =
    useOptionalHotelIntegration('useNearestAirports') ??
    fallbackUseNearestAirports;
  return useImpl();
};

export const useResolvedMalaysianEInvoice = (
  params: HotelMalaysianEInvoiceParams,
): HotelMalaysianEInvoiceResult => {
  const useImpl =
    useOptionalHotelIntegration('useMalaysianEInvoice') ??
    fallbackUseMalaysianEInvoice;
  return useImpl(params);
};
